/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  APIAllInOneUser,
  APIAllInOneUserRequest,
  APIOrgUserCreationRequest,
  APIPaginatedAllInOneUserList,
  APIPatchedAllInOneUserRequest,
  APIPatchedUserPreferencesRequest,
  APIUserPreferences,
  APIUserPreferencesRequest,
} from '../models/index';
import {
    APIAllInOneUserFromJSON,
    APIAllInOneUserToJSON,
    APIAllInOneUserRequestFromJSON,
    APIAllInOneUserRequestToJSON,
    APIOrgUserCreationRequestFromJSON,
    APIOrgUserCreationRequestToJSON,
    APIPaginatedAllInOneUserListFromJSON,
    APIPaginatedAllInOneUserListToJSON,
    APIPatchedAllInOneUserRequestFromJSON,
    APIPatchedAllInOneUserRequestToJSON,
    APIPatchedUserPreferencesRequestFromJSON,
    APIPatchedUserPreferencesRequestToJSON,
    APIUserPreferencesFromJSON,
    APIUserPreferencesToJSON,
    APIUserPreferencesRequestFromJSON,
    APIUserPreferencesRequestToJSON,
} from '../models/index';

export interface V1AccountsUsersCreateRequest {
    aPIOrgUserCreationRequest: APIOrgUserCreationRequest;
}

export interface V1AccountsUsersDestroyRequest {
    id: string;
}

export interface V1AccountsUsersListRequest {
    page?: number;
    pageSize?: number;
}

export interface V1AccountsUsersPartialUpdateRequest {
    id: string;
    aPIPatchedAllInOneUserRequest?: APIPatchedAllInOneUserRequest;
}

export interface V1AccountsUsersPreferencesPartialUpdateRequest {
    id: string;
    aPIPatchedUserPreferencesRequest?: APIPatchedUserPreferencesRequest;
}

export interface V1AccountsUsersPreferencesRetrieveRequest {
    id: string;
}

export interface V1AccountsUsersPreferencesUpdateRequest {
    id: string;
    aPIUserPreferencesRequest?: APIUserPreferencesRequest;
}

export interface V1AccountsUsersRetrieveRequest {
    id: string;
}

export interface V1AccountsUsersUpdateRequest {
    id: string;
    aPIAllInOneUserRequest?: APIAllInOneUserRequest;
}

export interface V1ChatChannelMembersCreateRequest {
    channelPk: string;
    aPIOrgUserCreationRequest: APIOrgUserCreationRequest;
}

export interface V1ChatChannelMembersDestroyRequest {
    channelPk: string;
    id: string;
}

export interface V1ChatChannelMembersListRequest {
    channelPk: string;
    page?: number;
    pageSize?: number;
}

export interface V1ChatChannelMembersPartialUpdateRequest {
    channelPk: string;
    id: string;
    aPIPatchedAllInOneUserRequest?: APIPatchedAllInOneUserRequest;
}

export interface V1ChatChannelMembersPreferencesPartialUpdateRequest {
    channelPk: string;
    id: string;
    aPIPatchedUserPreferencesRequest?: APIPatchedUserPreferencesRequest;
}

export interface V1ChatChannelMembersPreferencesRetrieveRequest {
    channelPk: string;
    id: string;
}

export interface V1ChatChannelMembersPreferencesUpdateRequest {
    channelPk: string;
    id: string;
    aPIUserPreferencesRequest?: APIUserPreferencesRequest;
}

export interface V1ChatChannelMembersRetrieveRequest {
    channelPk: string;
    id: string;
}

export interface V1ChatChannelMembersUpdateRequest {
    channelPk: string;
    id: string;
    aPIAllInOneUserRequest?: APIAllInOneUserRequest;
}

/**
 * 
 */
export class AccountsusersApi extends runtime.BaseAPI {

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1AccountsUsersCreateRaw(requestParameters: V1AccountsUsersCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['aPIOrgUserCreationRequest'] == null) {
            throw new runtime.RequiredError(
                'aPIOrgUserCreationRequest',
                'Required parameter "aPIOrgUserCreationRequest" was null or undefined when calling v1AccountsUsersCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/accounts/users/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: APIOrgUserCreationRequestToJSON(requestParameters['aPIOrgUserCreationRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1AccountsUsersCreate(requestParameters: V1AccountsUsersCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.v1AccountsUsersCreateRaw(requestParameters, initOverrides);
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1AccountsUsersDestroyRaw(requestParameters: V1AccountsUsersDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1AccountsUsersDestroy().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/accounts/users/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1AccountsUsersDestroy(requestParameters: V1AccountsUsersDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.v1AccountsUsersDestroyRaw(requestParameters, initOverrides);
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1AccountsUsersListRaw(requestParameters: V1AccountsUsersListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIPaginatedAllInOneUserList>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/accounts/users/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIPaginatedAllInOneUserListFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1AccountsUsersList(requestParameters: V1AccountsUsersListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIPaginatedAllInOneUserList> {
        const response = await this.v1AccountsUsersListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1AccountsUsersPartialUpdateRaw(requestParameters: V1AccountsUsersPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIAllInOneUser>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1AccountsUsersPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/accounts/users/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: APIPatchedAllInOneUserRequestToJSON(requestParameters['aPIPatchedAllInOneUserRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIAllInOneUserFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1AccountsUsersPartialUpdate(requestParameters: V1AccountsUsersPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIAllInOneUser> {
        const response = await this.v1AccountsUsersPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * View that enables user preferences management. Note: creating and deleting a user preference instance is only possible     by creating or deleting a user itself.
     */
    async v1AccountsUsersPreferencesPartialUpdateRaw(requestParameters: V1AccountsUsersPreferencesPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIUserPreferences>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1AccountsUsersPreferencesPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/accounts/users/{id}/preferences/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: APIPatchedUserPreferencesRequestToJSON(requestParameters['aPIPatchedUserPreferencesRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIUserPreferencesFromJSON(jsonValue));
    }

    /**
     * View that enables user preferences management. Note: creating and deleting a user preference instance is only possible     by creating or deleting a user itself.
     */
    async v1AccountsUsersPreferencesPartialUpdate(requestParameters: V1AccountsUsersPreferencesPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIUserPreferences> {
        const response = await this.v1AccountsUsersPreferencesPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * View that enables user preferences management. Note: creating and deleting a user preference instance is only possible     by creating or deleting a user itself.
     */
    async v1AccountsUsersPreferencesRetrieveRaw(requestParameters: V1AccountsUsersPreferencesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIUserPreferences>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1AccountsUsersPreferencesRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/accounts/users/{id}/preferences/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIUserPreferencesFromJSON(jsonValue));
    }

    /**
     * View that enables user preferences management. Note: creating and deleting a user preference instance is only possible     by creating or deleting a user itself.
     */
    async v1AccountsUsersPreferencesRetrieve(requestParameters: V1AccountsUsersPreferencesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIUserPreferences> {
        const response = await this.v1AccountsUsersPreferencesRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * View that enables user preferences management. Note: creating and deleting a user preference instance is only possible     by creating or deleting a user itself.
     */
    async v1AccountsUsersPreferencesUpdateRaw(requestParameters: V1AccountsUsersPreferencesUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIUserPreferences>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1AccountsUsersPreferencesUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/accounts/users/{id}/preferences/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: APIUserPreferencesRequestToJSON(requestParameters['aPIUserPreferencesRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIUserPreferencesFromJSON(jsonValue));
    }

    /**
     * View that enables user preferences management. Note: creating and deleting a user preference instance is only possible     by creating or deleting a user itself.
     */
    async v1AccountsUsersPreferencesUpdate(requestParameters: V1AccountsUsersPreferencesUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIUserPreferences> {
        const response = await this.v1AccountsUsersPreferencesUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1AccountsUsersRetrieveRaw(requestParameters: V1AccountsUsersRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIAllInOneUser>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1AccountsUsersRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/accounts/users/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIAllInOneUserFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1AccountsUsersRetrieve(requestParameters: V1AccountsUsersRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIAllInOneUser> {
        const response = await this.v1AccountsUsersRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1AccountsUsersUpdateRaw(requestParameters: V1AccountsUsersUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIAllInOneUser>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1AccountsUsersUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/accounts/users/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: APIAllInOneUserRequestToJSON(requestParameters['aPIAllInOneUserRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIAllInOneUserFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1AccountsUsersUpdate(requestParameters: V1AccountsUsersUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIAllInOneUser> {
        const response = await this.v1AccountsUsersUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ChatChannelMembersCreateRaw(requestParameters: V1ChatChannelMembersCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['channelPk'] == null) {
            throw new runtime.RequiredError(
                'channelPk',
                'Required parameter "channelPk" was null or undefined when calling v1ChatChannelMembersCreate().'
            );
        }

        if (requestParameters['aPIOrgUserCreationRequest'] == null) {
            throw new runtime.RequiredError(
                'aPIOrgUserCreationRequest',
                'Required parameter "aPIOrgUserCreationRequest" was null or undefined when calling v1ChatChannelMembersCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/chat/channel/{channel_pk}/members/`.replace(`{${"channel_pk"}}`, encodeURIComponent(String(requestParameters['channelPk']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: APIOrgUserCreationRequestToJSON(requestParameters['aPIOrgUserCreationRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ChatChannelMembersCreate(requestParameters: V1ChatChannelMembersCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.v1ChatChannelMembersCreateRaw(requestParameters, initOverrides);
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ChatChannelMembersDestroyRaw(requestParameters: V1ChatChannelMembersDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['channelPk'] == null) {
            throw new runtime.RequiredError(
                'channelPk',
                'Required parameter "channelPk" was null or undefined when calling v1ChatChannelMembersDestroy().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ChatChannelMembersDestroy().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/chat/channel/{channel_pk}/members/{id}/`.replace(`{${"channel_pk"}}`, encodeURIComponent(String(requestParameters['channelPk']))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ChatChannelMembersDestroy(requestParameters: V1ChatChannelMembersDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.v1ChatChannelMembersDestroyRaw(requestParameters, initOverrides);
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ChatChannelMembersListRaw(requestParameters: V1ChatChannelMembersListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIPaginatedAllInOneUserList>> {
        if (requestParameters['channelPk'] == null) {
            throw new runtime.RequiredError(
                'channelPk',
                'Required parameter "channelPk" was null or undefined when calling v1ChatChannelMembersList().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/chat/channel/{channel_pk}/members/`.replace(`{${"channel_pk"}}`, encodeURIComponent(String(requestParameters['channelPk']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIPaginatedAllInOneUserListFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ChatChannelMembersList(requestParameters: V1ChatChannelMembersListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIPaginatedAllInOneUserList> {
        const response = await this.v1ChatChannelMembersListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ChatChannelMembersPartialUpdateRaw(requestParameters: V1ChatChannelMembersPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIAllInOneUser>> {
        if (requestParameters['channelPk'] == null) {
            throw new runtime.RequiredError(
                'channelPk',
                'Required parameter "channelPk" was null or undefined when calling v1ChatChannelMembersPartialUpdate().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ChatChannelMembersPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/chat/channel/{channel_pk}/members/{id}/`.replace(`{${"channel_pk"}}`, encodeURIComponent(String(requestParameters['channelPk']))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: APIPatchedAllInOneUserRequestToJSON(requestParameters['aPIPatchedAllInOneUserRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIAllInOneUserFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ChatChannelMembersPartialUpdate(requestParameters: V1ChatChannelMembersPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIAllInOneUser> {
        const response = await this.v1ChatChannelMembersPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * View that enables user preferences management. Note: creating and deleting a user preference instance is only possible     by creating or deleting a user itself.
     */
    async v1ChatChannelMembersPreferencesPartialUpdateRaw(requestParameters: V1ChatChannelMembersPreferencesPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIUserPreferences>> {
        if (requestParameters['channelPk'] == null) {
            throw new runtime.RequiredError(
                'channelPk',
                'Required parameter "channelPk" was null or undefined when calling v1ChatChannelMembersPreferencesPartialUpdate().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ChatChannelMembersPreferencesPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/chat/channel/{channel_pk}/members/{id}/preferences/`.replace(`{${"channel_pk"}}`, encodeURIComponent(String(requestParameters['channelPk']))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: APIPatchedUserPreferencesRequestToJSON(requestParameters['aPIPatchedUserPreferencesRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIUserPreferencesFromJSON(jsonValue));
    }

    /**
     * View that enables user preferences management. Note: creating and deleting a user preference instance is only possible     by creating or deleting a user itself.
     */
    async v1ChatChannelMembersPreferencesPartialUpdate(requestParameters: V1ChatChannelMembersPreferencesPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIUserPreferences> {
        const response = await this.v1ChatChannelMembersPreferencesPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * View that enables user preferences management. Note: creating and deleting a user preference instance is only possible     by creating or deleting a user itself.
     */
    async v1ChatChannelMembersPreferencesRetrieveRaw(requestParameters: V1ChatChannelMembersPreferencesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIUserPreferences>> {
        if (requestParameters['channelPk'] == null) {
            throw new runtime.RequiredError(
                'channelPk',
                'Required parameter "channelPk" was null or undefined when calling v1ChatChannelMembersPreferencesRetrieve().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ChatChannelMembersPreferencesRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/chat/channel/{channel_pk}/members/{id}/preferences/`.replace(`{${"channel_pk"}}`, encodeURIComponent(String(requestParameters['channelPk']))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIUserPreferencesFromJSON(jsonValue));
    }

    /**
     * View that enables user preferences management. Note: creating and deleting a user preference instance is only possible     by creating or deleting a user itself.
     */
    async v1ChatChannelMembersPreferencesRetrieve(requestParameters: V1ChatChannelMembersPreferencesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIUserPreferences> {
        const response = await this.v1ChatChannelMembersPreferencesRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * View that enables user preferences management. Note: creating and deleting a user preference instance is only possible     by creating or deleting a user itself.
     */
    async v1ChatChannelMembersPreferencesUpdateRaw(requestParameters: V1ChatChannelMembersPreferencesUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIUserPreferences>> {
        if (requestParameters['channelPk'] == null) {
            throw new runtime.RequiredError(
                'channelPk',
                'Required parameter "channelPk" was null or undefined when calling v1ChatChannelMembersPreferencesUpdate().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ChatChannelMembersPreferencesUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/chat/channel/{channel_pk}/members/{id}/preferences/`.replace(`{${"channel_pk"}}`, encodeURIComponent(String(requestParameters['channelPk']))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: APIUserPreferencesRequestToJSON(requestParameters['aPIUserPreferencesRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIUserPreferencesFromJSON(jsonValue));
    }

    /**
     * View that enables user preferences management. Note: creating and deleting a user preference instance is only possible     by creating or deleting a user itself.
     */
    async v1ChatChannelMembersPreferencesUpdate(requestParameters: V1ChatChannelMembersPreferencesUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIUserPreferences> {
        const response = await this.v1ChatChannelMembersPreferencesUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ChatChannelMembersRetrieveRaw(requestParameters: V1ChatChannelMembersRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIAllInOneUser>> {
        if (requestParameters['channelPk'] == null) {
            throw new runtime.RequiredError(
                'channelPk',
                'Required parameter "channelPk" was null or undefined when calling v1ChatChannelMembersRetrieve().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ChatChannelMembersRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/chat/channel/{channel_pk}/members/{id}/`.replace(`{${"channel_pk"}}`, encodeURIComponent(String(requestParameters['channelPk']))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIAllInOneUserFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ChatChannelMembersRetrieve(requestParameters: V1ChatChannelMembersRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIAllInOneUser> {
        const response = await this.v1ChatChannelMembersRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ChatChannelMembersUpdateRaw(requestParameters: V1ChatChannelMembersUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIAllInOneUser>> {
        if (requestParameters['channelPk'] == null) {
            throw new runtime.RequiredError(
                'channelPk',
                'Required parameter "channelPk" was null or undefined when calling v1ChatChannelMembersUpdate().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ChatChannelMembersUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/chat/channel/{channel_pk}/members/{id}/`.replace(`{${"channel_pk"}}`, encodeURIComponent(String(requestParameters['channelPk']))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: APIAllInOneUserRequestToJSON(requestParameters['aPIAllInOneUserRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIAllInOneUserFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ChatChannelMembersUpdate(requestParameters: V1ChatChannelMembersUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIAllInOneUser> {
        const response = await this.v1ChatChannelMembersUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
